import { SearchValueType } from '../interface/app-header';
import { ValidatorFunction } from '../interface/UploadPhotosVideos.interface';
export type InputType =
  | 'project_number'
  | 'po_number'
  | 'client'
  | 'phone'
  | 'address';

interface ValidationResult {
  status: boolean;
  message: string;
}

const validators: Record<InputType, ValidatorFunction> = {
  project_number: (val: string) => {
    const isValid = typeof val === 'string' && val.length <= 30;

    return isValid
      ? { status: true, message: 'Valid' }
      : { status: false, message: 'Invalid project number' };
  },

  po_number: (val: string) => {
    const isValid = typeof val === 'string' && val.length <= 30;

    return isValid
      ? { status: true, message: 'Valid' }
      : { status: false, message: 'Invalid po number' };
  },

  client: (val: string) => {
    const isValid =
      typeof val === 'string' &&
      val.trim().length <= 50 &&
      /^[A-Za-z0-9]+(?:\s+[A-Za-z0-9]+)*$/.test(val.trim());

    return isValid
      ? { status: true, message: 'Valid' }
      : { status: false, message: 'Invalid client name' };
  },

  phone: (val: string) => {
    if (typeof val !== 'string') {
      return { status: false, message: 'Invalid phone number' };
    }

    const allowedFormat = /^[0-9()\-\s]*$/;
    if (!allowedFormat.test(val)) {
      return { status: false, message: 'Invalid phone number' };
    }

    const digitsOnly = val.replace(/\D/g, '');

    const isValid = digitsOnly.length <= 10;

    return isValid
      ? { status: true, message: 'Valid' }
      : { status: false, message: 'Invalid phone number' };
  },

  address: (val: string) => {
    const isValid =
      typeof val === 'string' && val.trim().length > 0 && val.length <= 100;

    return isValid
      ? { status: true, message: 'Valid' }
      : { status: false, message: 'Invalid address' };
  },
};

const genericStringValidator: ValidatorFunction = (val: string) => {
  const isValid = typeof val === 'string' && val.length <= 30;

  return isValid
    ? { status: true, message: 'Valid' }
    : { status: false, message: 'Invalid search value' };
};

export function validateGlobalSearchInput(
  type: string,
  value: string | SearchValueType
): ValidationResult {
  if (typeof value === 'object') {
    return { status: true, message: '' };
  }
  const validatorFn = validators[type as InputType] || genericStringValidator;
  return validatorFn(value);
}

export const getProjectViewEditPath = (pathname: string): boolean => {
  if (!pathname) return false;
  const segments = pathname?.split('/');
  const isProjectViewEdit = segments?.slice(1, 3).join('/');
  return (
    isProjectViewEdit === 'project/view' || isProjectViewEdit === 'project/edit'
  );
};
